import { render, staticRenderFns } from "./RemoveCandidate.vue?vue&type=template&id=e5f88026&scoped=true&"
import script from "./RemoveCandidate.vue?vue&type=script&lang=js&"
export * from "./RemoveCandidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f88026",
  null
  
)

export default component.exports